import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const StyledText = styled(Typography)({
  marginLeft: '0.25rem',
});
